module.exports = __webpack_public_path__ + "img/gnzs6.28ee07b4.png";